import MUISkeleton, { SkeletonProps } from '@mui/material/Skeleton';

import { SystemStyleObject } from '@mui/system';

import Box from '../Box';
import radius from '../Theme/radius';
import Repeat from '../Repeat';

import { SxProps, Theme } from '../styles';

type Variant = Exclude<SkeletonProps['variant'], undefined>;

const MUI_VARIANT: { [key in Variant]: SystemStyleObject<Theme> } = {
  circular: {
    backgroundColor: 'skeleton.image',
    width: 200,
    height: 200,
  },
  rectangular: {
    backgroundColor: 'skeleton.text',
  },
  rounded: {
    backgroundColor: 'skeleton.image',
  },
  text: {
    backgroundColor: 'skeleton.text',
    height: 26,
    maxWidth: 768,
    borderRadius: 0,
  },
  button: {
    backgroundColor: 'skeleton.badge',
    height: 40,
    width: 100,
    borderRadius: radius.button,
  },
};

export interface Props extends Omit<SkeletonProps, 'animation'> {
  count?: number;
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

const Skeleton = ({
  count = 1,
  variant = 'text',
  children,
  sx = {},
  height,
  width,
  ...otherProps
}: Props) => (
  <Box
    sx={{
      width,
      height,
    }}
    {...otherProps}
  >
    <Repeat count={count}>
      <MUISkeleton
        variant={variant}
        animation="wave"
        height={height}
        width={width}
        sx={{ ...MUI_VARIANT[variant], ...sx }}
      >
        {children}
      </MUISkeleton>
    </Repeat>
  </Box>
);

export default Skeleton;
